import * as React from 'react';
import { ShippingLineText, StyledActionText } from './helpers/styles';
import { FormattedMessage } from 'react-intl';
import isEqual from 'react-fast-compare';
import styled from 'styled-components';
import ZipcodeForm from './ZipcodeForm';

type Props = {
    itemId: number;
    setShippingToLocation: Function;
    setShowShippingToLocation: Function;
    shippingToLocation: { countryCode: string; zip: string };
    showShippingToLocation: boolean;
};

/**
 * Displays either a "ship to zip" line or a form to calculate shipping from a given country + zip code
 */
const ShippingToLine = ({
    itemId,
    setShippingToLocation,
    setShowShippingToLocation,
    shippingToLocation,
    showShippingToLocation,
}: Props) => {
    if (showShippingToLocation) {
        return (
            <div>
                <StyledShippingLineText>
                    {Boolean(shippingToLocation.countryCode) ? (
                        <FormattedMessage
                            id="shippingInfo.shippingTo.shippingToLine"
                            values={{ countryCode: shippingToLocation.countryCode, zip: shippingToLocation.zip }}
                        />
                    ) : (
                        <FormattedMessage
                            id="shippingInfo.shippingTo.shippingToLineWOCountryCode"
                            values={{ zip: shippingToLocation.zip }}
                        />
                    )}
                </StyledShippingLineText>
                <StyledActionText onClick={() => setShowShippingToLocation(false)}>
                    <FormattedMessage id="shippingInfo.shippingTo.changeZipButton" />
                </StyledActionText>
            </div>
        );
    }

    return (
        <ZipcodeForm
            countryCode={shippingToLocation.countryCode || 'US'}
            itemId={itemId}
            setShippingToLocation={setShippingToLocation}
            setShowShippingToLocation={() => setShowShippingToLocation(true)}
            zip={shippingToLocation.zip}
        />
    );
};

export default React.memo<Props>(ShippingToLine, isEqual);

const StyledShippingLineText = styled(ShippingLineText)`
    && {
        margin-right: 10px;
    }
`;
